import React, { createContext } from 'react';
import { WalkthruItem, WalkthruState } from '@/shared/walkthru';
import { FeatureFlagTypes, MediaObject } from '@/shared/types';
import { TpToastProps } from '@/components/ui/toast';

export interface FeaturesContextType {
  flagsFromLD: { [key: string]: FeatureFlagTypes };
  featureFlags: { [key: string]: FeatureFlagTypes };
  flagOverrides: { [key: string]: FeatureFlagTypes };
  setFlagOverrides: (flagOverrides: { [key: string]: FeatureFlagTypes }) => void;
}

export const FeaturesContext = createContext<FeaturesContextType | null>(null);

export interface FullScreenContextType {
  isFullscreen: boolean;
  setIsFullscreen: (isFullscreen: boolean) => void;
  fullscreenMediaItem: MediaObject | null;
  setFullscreenMediaItem: React.Dispatch<React.SetStateAction<MediaObject | null>>;
  linkedMediaItem: MediaObject | null;
  setLinkedMediaItem: (mediaItem: MediaObject | null) => void;
  fullScreenCaptureData: string | undefined;
  setFullScreenCaptureData: (captureData: string | undefined) => void;
}

export const FullScreenContext = createContext<FullScreenContextType>({
  isFullscreen: false,
  setIsFullscreen: () => {},
  fullscreenMediaItem: null,
  setFullscreenMediaItem: () => {},
  linkedMediaItem: null,
  setLinkedMediaItem: () => {},
  fullScreenCaptureData: undefined,
  setFullScreenCaptureData: () => {}
});

export interface ToastContextType {
  setToast: (toast: TpToastProps | undefined) => void;
  setToastOpen: (open: boolean) => void;
}

export const ToastContext = createContext<ToastContextType>({
  setToast: () => {},
  setToastOpen: () => {},
});

export interface StatsContextType {
  recordStat: (
    eventName: string | undefined,
    event: React.MouseEvent<HTMLButtonElement | any>,
    statsContext: {
      userInfo: {
        userId: string;
        sessionId: string;
        caseId: string;
        query: string
      }
    },
    useIntercom: boolean
  ) => void;

  userInfo: {
    userId: string;
    sessionId: string;
    query: string;
    caseId: string;
    page: string;
  };
}

export const StatsContext = createContext<StatsContextType>({
  recordStat: () => {},
  userInfo: {
    userId: '',
    sessionId: '',
    query: '',
    caseId: '',
    page: ''
  }
});

export interface AuthContextType {
  idToken: string | null;
  accessToken: string | null;
  tenantName: string | null;
  orgName: string | null;
}

export const AuthContext = createContext<AuthContextType>({
  idToken: null,
  accessToken: null,
  tenantName: null,
  orgName: null,
});


export interface WalkthruContextType {
  walkthrus: Record<string, WalkthruState> | null;
  availableWalkthrus: Record<string, WalkthruItem[]> | null;
  setWalkthru: (name: string, walkthru: WalkthruState) => void;
}

export const WalkthruContext = createContext<WalkthruContextType>({
  walkthrus: {},
  availableWalkthrus: {} as any,
  setWalkthru: (name: string, walkthru: WalkthruState) => {}
});